export default class CreateCounselingAndConsultancyCtrl {

  constructor ($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, WorkPlanModalSrv, $cookies, GlobalConfig, GlobalSrv) {
    var createCounselingAndConsultancyVm = this
    const texts = GlobalConfig.appTexts
    createCounselingAndConsultancyVm.currentUser = JSON.parse($cookies.get('currentUser'))

    let post = {
      workplanId: createCounselingAndConsultancyVm.currentUser.workplanId,
      teacherId: createCounselingAndConsultancyVm.currentUser.teacherId,
      name: createCounselingAndConsultancyVm.currentUser.name
    }
    createCounselingAndConsultancyVm.listBasicAreaOfKnowledge = []
    createCounselingAndConsultancyVm.sectorType = []
    createCounselingAndConsultancyVm.rolType = []

    createCounselingAndConsultancyVm.isEditing = ($stateParams.workplanTeacherActivityId) ? true : false
    createCounselingAndConsultancyVm.rangeType = GlobalConfig.periods.rangeType
    createCounselingAndConsultancyVm.workplanTeacherActivityId = null
    createCounselingAndConsultancyVm.createOrEdit = 'Crear'
    createCounselingAndConsultancyVm.textCreateOrEdit = texts.saved
    createCounselingAndConsultancyVm.createOrEditMV = texts.createDialog
    createCounselingAndConsultancyVm.financiers = []
    createCounselingAndConsultancyVm.isTouchedFinanciers = false
    createCounselingAndConsultancyVm.typePeriod = []
    createCounselingAndConsultancyVm.periodsArray = []
    createCounselingAndConsultancyVm.selectedTypePeriod = {}
    createCounselingAndConsultancyVm.isTouchedPeriods = false
    createCounselingAndConsultancyVm.startDate = null
    createCounselingAndConsultancyVm.endDate = null
    createCounselingAndConsultancyVm.minStartDate = moment().toDate()
    createCounselingAndConsultancyVm.minEndDate = new Date()
    createCounselingAndConsultancyVm.isSaveButtonDisabled = false
    createCounselingAndConsultancyVm.isFeedback = createCounselingAndConsultancyVm.currentUser.isFeedback
    createCounselingAndConsultancyVm.dt_start = $cookies.get('wp_start')
    createCounselingAndConsultancyVm.dt_end = $cookies.get('wp_end')

    createCounselingAndConsultancyVm.hasError = hasError
    createCounselingAndConsultancyVm.showErrorMessages = showErrorMessages
    createCounselingAndConsultancyVm.confirmCounselingAndConsultancyAction = confirmCounselingAndConsultancyAction
    createCounselingAndConsultancyVm.validateForm = validateForm
    createCounselingAndConsultancyVm.validateCheklistPeriods = validateCheklistPeriods
    createCounselingAndConsultancyVm.funSelectedPeriod = funSelectedPeriod
    createCounselingAndConsultancyVm.cleanRangeType = cleanRangeType
    createCounselingAndConsultancyVm.startDateChange = startDateChange
    createCounselingAndConsultancyVm.addCounselingAndConsultancy = addCounselingAndConsultancy
    createCounselingAndConsultancyVm.addOrEditCounselingAndConsultancy = addOrEditCounselingAndConsultancy
    createCounselingAndConsultancyVm.close = close

    createCounselingAndConsultancyVm.updateRangeType = (val) => {
      createCounselingAndConsultancyVm.rangeType = val
      createCounselingAndConsultancyVm.periodsArray = []
      createCounselingAndConsultancyVm.startDate = null
      createCounselingAndConsultancyVm.endDate = null
    }
    createCounselingAndConsultancyVm.updateRangeData = (val) => {
      createCounselingAndConsultancyVm.periodsArray = val['periods']
      createCounselingAndConsultancyVm.startDate = val['dates'][0]
      createCounselingAndConsultancyVm.endDate = val['dates'][1]
    }

    activate()

    function activate () {
      if (createCounselingAndConsultancyVm.isEditing) {
        createCounselingAndConsultancyVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId
        createCounselingAndConsultancyVm.createOrEdit = 'Editar'
        createCounselingAndConsultancyVm.createOrEditMV = texts.editDialog
        createCounselingAndConsultancyVm.textCreateOrEdit = texts.modified
        getDataCounselingAndConsultancy()
      }
      WorkPlanSrv.getDataFormAdviceConsultancy.getList(post).$promise.then(
          dataReturn => {
            if (dataReturn.status) {
              loadData(dataReturn)
            } else {
              console.log('Comunications problem')
            }
          },
          data => {
            console.log(data)
          }
        )
    }

    function getDataCounselingAndConsultancy () {
      let post = {
        workplanTeacherActivityId: parseInt(createCounselingAndConsultancyVm.workplanTeacherActivityId)
      }

      WorkPlanSrv.getAdviceConsultancyById.get(post).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          setValues(dataReturn.data)
        } else {
          console.log('Comunications problem with the server')
        }
      })
    }

    function loadData (data) {
      createCounselingAndConsultancyVm.listsTypeBasicAreaOfKnowledge = data.listKnowledge.items
      createCounselingAndConsultancyVm.listsTypeAmbitStage = data.listAmbit.items
      createCounselingAndConsultancyVm.sectorType = data.listSector.items
      createCounselingAndConsultancyVm.rolType = data.listRole.items
      createCounselingAndConsultancyVm.typePeriod = data.listPeriods
      createCounselingAndConsultancyVm.financiers = data.listFinancial
    }

    function addCounselingAndConsultancy (isExecution) {
      let origin = GlobalConfig.activityTypeId.originActivityPlanning
      if (isExecution) {
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function createJson (origin) {
      var counselingConsultancy = {
        activityId: GlobalConfig.minorActivityId.counseling,
        teacherId: post.teacherId,
        workplanId: post.workplanId,
        name: createCounselingAndConsultancyVm.nameCounselingConsultancy,
        description: createCounselingAndConsultancyVm.description,
        hoursPlanning: createCounselingAndConsultancyVm.plannedHours,
        deliverables: createCounselingAndConsultancyVm.productsDeliverables,
        itemKnowledgeId: createCounselingAndConsultancyVm.basicAreaOfKnowledgeType,
        entity: createCounselingAndConsultancyVm.companyEntityOrganization,
        source: createCounselingAndConsultancyVm.source,
        itemSectorId: createCounselingAndConsultancyVm.sector,
        itemRoleId: createCounselingAndConsultancyVm.rol,
        itemSpaceId: createCounselingAndConsultancyVm.ambitStage,
        timeRangeTypeId: parseInt(createCounselingAndConsultancyVm.rangeType),
        origin: origin,
        isFeedbackActivity: createCounselingAndConsultancyVm.isFeedback
      }

      if (parseInt(createCounselingAndConsultancyVm.rangeType) === GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        for (var index in createCounselingAndConsultancyVm.periodsArray) {
          var temp = {
            periodId: createCounselingAndConsultancyVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        counselingConsultancy.periods = arrayPeriod
      } else {
        counselingConsultancy.startDate = new Date(createCounselingAndConsultancyVm.startDate)
        counselingConsultancy.endDate = new Date(createCounselingAndConsultancyVm.endDate)
      }

      if (createCounselingAndConsultancyVm.isEditing) {
        counselingConsultancy.workplanTeacherActivityId = createCounselingAndConsultancyVm.workplanTeacherActivityId
      }
      addOrEditCounselingAndConsultancy(counselingConsultancy)
    }

    function addOrEditCounselingAndConsultancy (counselingConsultancy) {
      createCounselingAndConsultancyVm.isSaveButtonDisabled = true
      WorkPlanSrv.addAdviceConsultancy.save(counselingConsultancy).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          getSendNotify(counselingConsultancy.origin)
          confirmCounselingAndConsultancyAction()
        } else {
          createCounselingAndConsultancyVm.isSaveButtonDisabled = false
          console.log('Error Comunications')
        }
      }, function (data) {
        createCounselingAndConsultancyVm.isSaveButtonDisabled = false
      })
    }

    function confirmCounselingAndConsultancyAction () {
      let header = {
        createOrEdit: createCounselingAndConsultancyVm.createOrEditMV,
        textCreateOrEdit: createCounselingAndConsultancyVm.textCreateOrEdit,
        itemName: createCounselingAndConsultancyVm.nameCounselingConsultancy,
        nameModal: texts.modalTypeName.counselingConsultancy,
        modalType: texts.modalTypeId.counselingConsultancy
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header)
    }

    function hasError (input) {
      if (input && input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input && (input.$dirty || input.$touched)
    }

    function validateForm (form) {
      return (form && form.$invalid) || createCounselingAndConsultancyVm.validateCheklistPeriods()
    }

    function validateCheklistPeriods () {
      return (createCounselingAndConsultancyVm.rangeType == 1 ? createCounselingAndConsultancyVm.periodsArray.length < 1 : false)
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!createCounselingAndConsultancyVm.periodsArray.includes(period.periodId)) {
          createCounselingAndConsultancyVm.periodsArray.push(period.periodId)
        }
      } else {
        let index = createCounselingAndConsultancyVm.periodsArray.indexOf(period.periodId)
        if (index !== -1) {
          createCounselingAndConsultancyVm.periodsArray.splice(index, 1)
        }
      }
      createCounselingAndConsultancyVm.isTouchedPeriods = true
    }

    function startDateChange () {
      let m = moment(createCounselingAndConsultancyVm.startDate)
      createCounselingAndConsultancyVm.minEndDate = m.isValid() ? m/*.add(1, 'days')*/.toDate() : null
    }

    function setValues (counseling) {
      createCounselingAndConsultancyVm.nameCounselingConsultancy = counseling.name
      createCounselingAndConsultancyVm.plannedHours = counseling.hoursPlanned
      createCounselingAndConsultancyVm.description = counseling.description
      createCounselingAndConsultancyVm.productsDeliverables = counseling.deliverables
      createCounselingAndConsultancyVm.basicAreaOfKnowledgeType = counseling.itemKnowledgeId
      createCounselingAndConsultancyVm.companyEntityOrganization = counseling.entity
      createCounselingAndConsultancyVm.ambitStage = counseling.itemAmbitId
      createCounselingAndConsultancyVm.sector = counseling.itemSectorId
      createCounselingAndConsultancyVm.source = counseling.source
      createCounselingAndConsultancyVm.rol = counseling.itemRoleId
      createCounselingAndConsultancyVm.rangeType = counseling.timeRangeTypeId
      createCounselingAndConsultancyVm.dt_start = moment(counseling.startDate, 'YYYY-MM-DD').toDate()
      createCounselingAndConsultancyVm.dt_end = moment(counseling.endDate, 'YYYY-MM-DD').toDate()
      createCounselingAndConsultancyVm.periodsArray = []
      createCounselingAndConsultancyVm.selectedTypePeriod = {}
      createCounselingAndConsultancyVm.selectedFinancier = {}

      if (createCounselingAndConsultancyVm.rangeType == GlobalConfig.periods.rangeType) {
        var splits = counseling.periodId.split(',')
        createCounselingAndConsultancyVm.startDate = null
        createCounselingAndConsultancyVm.endDate = null

        if (splits) {
          for (var i = 0; i < splits.length; i++) {
            var valor = splits[i]
            createCounselingAndConsultancyVm.periodsArray.push(parseInt(valor))
            createCounselingAndConsultancyVm.selectedTypePeriod[valor] = true
          }
        }
      }

      if (counseling.startDate) {
        var startDateNew = moment(counseling.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          createCounselingAndConsultancyVm.minStartDate = moment(counseling.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }

      createCounselingAndConsultancyVm.isEditing = true
    }

    function cleanRangeType () {
      if (parseInt(createCounselingAndConsultancyVm.rangeType) == GlobalConfig.periods.rangeType) {
        createCounselingAndConsultancyVm.startDate = null
        createCounselingAndConsultancyVm.endDate = null
      } else {
        createCounselingAndConsultancyVm.periodsArray = []
        createCounselingAndConsultancyVm.selectedTypePeriod = null
      }
    }

    function close () {
      return $mdDialog.hide()
    }

    function getSendNotify (origin) {
      let msg = 'El profesor ' + createCounselingAndConsultancyVm.currentUser.dsFullname + ' ha registrado una nueva consultoria y asesoria en la etapa de '
      if (origin == GlobalConfig.activityTypeId.originActivityExecution)
        msg = msg+'ejecución.'
      else
        msg = msg+'planeación.'
      const data = {
        idTeacher: createCounselingAndConsultancyVm.currentUser.teacherId,
        dsName: 'Notificación, se agregó o editó una consultoria y asesoria',
        dsDescription: msg,
        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
        is_grouped: 1
      }
      GlobalSrv.sendNotificationsEvaluatorsSubmodule(data)
    }
  }// FIN DEL CONSTRUCTOR

  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) {
      event.preventDefault()
    }
    return
  }
}

CreateCounselingAndConsultancyCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/extensionVisibility/counselingAndConsultancy/create/createCounselingAndConsultancyCtrl.js